import { IInventoryPage } from '../../inventory-page.interface';


export const GENERAL_UI_FOUNDATION_PREVIEW_PAGE: IInventoryPage = {
	'route': '/ui-foundation-preview',
	'title': 'Ui Foundation Preview',
	'uiReference': [
		'Preview controls',
		'Product theme',
		'Color mode',
		'Search a keyword',
		'Isolated architecture sample',
		'Bootstrap source-themed as Flying V2',
		'This page uses standard Bootstrap classes and ng-bootstrap behavior only.',
		'Research',
		'Upload',
		'Light',
		'Dark',
		'Marketplace search',
		'Standard form and ng-bootstrap dropdown markup.',
		'Reset',
		'Marketplace',
		'Keyword',
		'Search',
		'Framework component states',
		'No custom button, field, card, badge, or alert component.',
		'Primary',
		'Outline',
		'Secondary',
		'Danger',
		'Disabled',
		'Selected',
		'Ready',
		'Attention',
		'Blocked',
		'Source contract',
		'What a new feature author writes.',
		'Keyword opportunities',
		'Standard responsive table styling.',
		'Export'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/ui-foundation-preview/ui-foundation-preview.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/ui-foundation-preview/ui-foundation-preview.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/ui-foundation-preview/ui-foundation-preview.v2.html'
	]
};
